import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bill-status',
  templateUrl: './bill-status.component.html',
  styleUrls: ['./bill-status.component.css']
})
export class BillStatusComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/technical/billing/bill-status/bill-status.component.ts